<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { getInboxSource } from 'dashboard/helper/inbox';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const router = useRouter();
const route = useRoute();

// The identifier people actually recognise a line by: the number, the address, the site. It used
// to be glued onto the name in a second pair of brackets - `Telefone (Twilio) (+5511...)` - which
// reads as one long name instead of a name and the thing it points at.
const source = computed(
  () =>
    getInboxSource(
      props.inbox.channel_type,
      props.inbox.phone_number,
      props.inbox
    ) ||
    // A Twilio line set up with a messaging service has no number of its own to show.
    props.inbox.messaging_service_sid ||
    ''
);

const goToInboxList = () => {
  router.push(
    frontendURL(`accounts/${route.params.accountId}/settings/inboxes/list`)
  );
};
</script>

<template>
  <div class="border-b border-solid border-n-weak/60">
    <div class="w-full px-6 pt-4 mx-auto max-w-7xl">
      <button
        class="flex items-center gap-0.5 p-0 -ml-1 text-sm font-normal cursor-pointer text-n-slate-11 hover:text-n-slate-12"
        @click="goToInboxList"
      >
        <i class="text-base i-lucide-chevron-left" />
        {{ $t('INBOX_MGMT.HEADER') }}
      </button>

      <div class="flex items-center gap-3 mt-3 mb-4">
        <Avatar
          :name="inbox.name"
          :src="inbox.avatarUrl"
          :inbox="inbox"
          :size="40"
          rounded-full
        />
        <div class="flex flex-col min-w-0">
          <h1 class="mb-0 text-xl font-medium truncate text-n-slate-12">
            {{ inbox.name }}
          </h1>
          <span v-if="source" class="text-sm truncate text-n-slate-11">
            {{ source }}
          </span>
        </div>
      </div>

      <slot />
    </div>
  </div>
</template>
